import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "title flex-center" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["data-title"]
const _hoisted_4 = {
  key: 0,
  class: "iconfont iconiconfontarrows"
}
const _hoisted_5 = {
  key: 0,
  class: "sec-nav"
}
const _hoisted_6 = ["onClick"]

import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";

type urlType = {
  route?: string;
  href?: string;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'Nav',
  props: {
  notHome: Boolean,
},
  setup(__props) {

const props = __props;
const tabList = [
  { title: "首页", route: "/home" },
  { title: "查看区块", route: "/block" },
  { title: "查看数据", route: "/tradelist" },
  { title: "Token", route: "/token" },
  { title: "解析数据", route: "/alytx" },
  { title: "广播数据", route: "/broadtx" },
];
const route = useRoute();
const router = useRouter();
let nowPath = computed(() => route.path);
function linkTo(url: urlType) {
  if (url.route) router.push(url.route);
  else if (url.href) window.open(url.href);
  else return;
}
function includeRoute(path: string, url: urlType) {
  if (url.route === "/token" && path === "/tokenDetail") return true;
  return JSON.stringify(url).includes(String(path));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(["head-nav flex-around", { 'not-home-nav': props.notHome }])
  }, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabList, (item, index) => {
      return _createElementVNode("li", {
        key: index,
        class: "flex-center-stright"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "nav-trans",
            onClick: ($event: any) => (linkTo(item))
          }, [
            _createElementVNode("span", {
              "data-title": item.title,
              class: _normalizeClass({
            'active-y': _unref(nowPath) === item.route && item.route === '/home',
            'active-b': includeRoute(_unref(nowPath), item) && item.route !== '/home',
          })
            }, _toDisplayString(item.title), 11, _hoisted_3)
          ], 8, _hoisted_2),
          (item.list)
            ? (_openBlock(), _createElementBlock("i", _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        (item.list)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (sec, secind) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: secind,
                  onClick: ($event: any) => (linkTo(sec)),
                  class: _normalizeClass({ 'active-b': _unref(nowPath) === sec.route })
                }, _toDisplayString(sec.title), 11, _hoisted_6))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "line" }, null, -1))
      ])
    }), 64))
  ], 2))
}
}

})